module.exports = __webpack_public_path__ + "img/slide-2.63dc71ac.png";